import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Syskb } from '../entity/Syskb-angular';

export interface SyskbData {     COMPANY: string ;     CREATOR: string;     USR_GROUP: string ;     CREATE_DATE: string;     MODIFIER: string;     MODI_DATE: string;     FLAG: number;     KB001: string;            // 日期 8     KB002: string;            // 時間 4     KB003: string;            // 重要性 1 [DEF:"3"] 1:極重要 2:重要 3:普通    KB004: string;            // 員工代號 10     KB005: string;            // 發佈人 10     KB006: string;            // 訊息 255     KB007: string;            // 群組代號 100 空白表全部    KB008: string;            // 失效日期 8     KB009: string;            // 網址 255     KB010: string;            // 需簽收 1 [DEF:"N"]    KB011: string;            // 地區代號 100 1010810 ADD}


@Injectable({
  providedIn: 'root'
})
export class SyskbServicePkg extends JkEntityV2 { 


  constructor() {
    super();
    this.linkMasterFields = '' ; 
    this.defaultItem = new Syskb(); 
    this.entityType.type = EntityType.master;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數', 
        KB001 : '日期' , KB002 : '時間' , KB003 : '重要性' , KB004 : '員工代號' , KB005 : '發佈人' , KB006 : '訊息' , KB007 : '群組代號' , KB008 : '失效日期' , KB009 : '網址' , KB010 : '需簽收' , KB011 : '地區代號'  }; 

    this.fieldNames = 'KB001,KB002,KB003,KB004,KB005,KB006,KB007,KB008,KB009,KB010,KB011' ;
    this.fieldLengths = {KB001 : 8 ,KB002 : 4 ,KB003 : 1 ,KB004 : 10 ,KB005 : 10 ,KB006 : 255 ,KB007 : 100 ,KB008 : 8 ,KB009 : 255 ,KB010 : 1 ,KB011 : 100 } ;
    this.columnDefs = [
      { field: "KB007", headerName: "群組代號",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "KB011", headerName: "地區代號",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "KB010", headerName: "需簽收",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "KB009", headerName: "網址",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "KB008", headerName: "失效日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "KB001", headerName: "日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "KB006", headerName: "訊息",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "KB005", headerName: "發佈人",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "KB004", headerName: "員工代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "KB003", headerName: "重要性",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "KB002", headerName: "時間",headerTooltip: "",width:102,cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSKB' ;
    this.isSys =true; 
    this.sqlSelect = `SELECT SYSKB.*  FROM SYSKB` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY KB001,KB002` ;
    this.keyFields = ['KB001','KB002'];
    this.url = '/db/crud'; 
    this.rememberFields = [];
    this.requiredFields = ['KB001','KB002'];
    this.seqField = '' ;
    this.seqFieldLength = 0 ;
  }
  override async validateItem(item: Syskb): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Syskb): Promise<Syskb> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

